import { DatePipe } from "@angular/common";
import { Component, Inject, OnInit } from "@angular/core";
import { UntypedFormControl, UntypedFormGroup, Validators } from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { SharedService } from "@shared/services/shared.service";
import { IBusinessInitialSiteVisitViewModel, IBusinessSiteVisitViewModel } from "app/models/complaints/siteVisit";
import { IAdministrativeComplaintView } from "app/models/mainMenu/mainMenu";
import { IEnclosedAreaEditHistory } from "app/models/reports/reports";
import { ComplaintService } from "app/services/complaint/complaint.service";
import { SiteVisitService } from "app/services/complaint/siteVisit.service";

@Component({
  selector: 'initialSiteVisitEdit',
  styleUrls: ['./initialSiteVisitEdit.component.scss'],
  templateUrl: './initialSiteVisitEdit.component.html'
})

export class InitialSiteVisitEditComponent implements OnInit {

  businessId: number = 0;
  saved: boolean = false;
  showSave: boolean = false;
  reviewed: boolean = false;
  followupInspection: boolean = false;
  siteVisitConducted: boolean = false;
  complaintDueDate: Date = null;
  followupFlag: boolean = false;
  localComplaint: IAdministrativeComplaintView = {} as IAdministrativeComplaintView;

  siteVisitItems: IBusinessSiteVisitViewModel = {} as IBusinessSiteVisitViewModel;
  siteVisit: IBusinessInitialSiteVisitViewModel = {} as IBusinessInitialSiteVisitViewModel;

  form = new UntypedFormGroup({
    visitDate: new UntypedFormControl(Date, [Validators.required]),
    visitConducted: new UntypedFormControl('', [Validators.required]),
    visitConductedReason: new UntypedFormControl(''),
    violationFound: new UntypedFormControl(''),
    comments: new UntypedFormControl('')
  });

  constructor(
    private sharedService: SharedService,
    private siteVisitService: SiteVisitService,
    private complaintService: ComplaintService,
    private datePipe: DatePipe,
    private dialogRef: MatDialogRef<InitialSiteVisitEditComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.siteVisit = this.data.siteVisit;
    this.siteVisitItems = this.siteVisitService.siteVisit;
    this.localComplaint = this.complaintService.currentComplaint;
    if (this.siteVisit != null && this.siteVisit != undefined && this.siteVisit.id != 0) {
      this.setFormData(this.siteVisit);
      this.showSave = true;
    }
    this.businessId = this.localComplaint.businessId;
  }

  ngOnInit(): void {
    this.saved = false;
  }

  save() {
    if (!this.form.valid) {
      this.sharedService.toastr.error("Please fill in all required fields");
      return;
    }
    else {
      this.setSaveData();

      this.siteVisitService.saveSiteVisits(this.businessId, this.siteVisitItems).subscribe({
        next: response => {
          this.sharedService.toastr.success("Saved");
          this.saved = true;
          this.return();
        },
        error: e => {
          this.sharedService.toastr.error("Could not save Site Visit data.");
        },
      });
    }

  }


  siteVisitUpdate(visited: string) {
    this.followupFlag = visited == '1' ? true : false;
  }


  setSaveData() {
    if (this.form.valid) {
      let data = this.form.value;

      if (this.siteVisit.id == 0) {
        this.siteVisit.visitDate = this.datePipe.transform(data.visitDate, 'MM/dd/yyyy');
        this.siteVisit.visitConducted = +data.visitConducted;
        this.siteVisit.visitConductedReason = +data.visitConductedReason;
        this.siteVisit.violationFound = +data.violationFound;
        this.siteVisit.notes = data.comments;
        this.siteVisitItems.initialSiteVisits.push(this.siteVisit);
      }
      else {

        let visit = this.siteVisitItems.initialSiteVisits.findIndex(x => x.id == this.siteVisit.id);
        if (visit != null) {
          this.siteVisitItems.initialSiteVisits[visit].visitDate = this.datePipe.transform(data.visitDate, 'MM/dd/yyyy');
          this.siteVisitItems.initialSiteVisits[visit].visitConducted = +data.visitConducted;
          this.siteVisitItems.initialSiteVisits[visit].visitConductedReason = +data.visitConductedReason;
          this.siteVisitItems.initialSiteVisits[visit].violationFound = +data.violationFound;
          this.siteVisitItems.initialSiteVisits[visit].notes = data.comments;
          this.siteVisitItems.initialSiteVisits[visit].allowEditing = true;
        }
      }
    }
  }

  setFormData(data: IBusinessInitialSiteVisitViewModel) {
    this.form.patchValue({
      visitDate: this.siteVisit.visitDate != null ? new Date(this.siteVisit.visitDate) : '',
      visitConducted: this.siteVisit.visitConducted != null ? this.siteVisit.visitConducted.toString() : '',
      visitConductedReason: this.siteVisit.visitConductedReason != null ? this.siteVisit.visitConductedReason.toString() : '',
      violationFound: this.siteVisit.violationFound != null ? this.siteVisit.violationFound.toString() : '',
      comments: this.siteVisit.notes
    });
    this.siteVisitUpdate(this.siteVisit.visitConducted.toString());
  }

  return(): void {
    let returnData = this.saved ? 'saved' : 'cancel';
    this.dialogRef.close(returnData);
  }
}